<base-section [index]="index" [section]="section">
  <div class="grid" [ngClass]="{'grid-section':!sectionRendered.is_full_width}">
    <div class="content" [innerHTML]="sectionRendered.content|safeHtml">

    </div>
  </div>
</base-section>
